import { animated, useSpring, config } from "@react-spring/web";
import { useEffect, useState } from "react";

type ShowAnimateProps = {
    show: boolean;
    children: any;
    x?: number;
    y?: number;
    z?: number;
    duration?: number;
    immediate?: boolean;
    className?: string;
    style?: any;
    speed?: "default" | "gentle"

};
export function ShowAnimate(props: ShowAnimateProps) {
    let { show, children, x = 0, y = 8, z = 0, duration = 200, immediate = false, className = "", style = {}, speed = "normal" } = props;
    let [_show, set_show] = useState(false);



    const styles = useSpring({
        opacity: 1,
        x, y, z,
        from: {
            opacity: 0,
            x: 0,
            y: 0,
            z: 0
        },
        reset: false, reverse: !show, immediate,
        config: speed === "gentle" ? config.gentle : config.default
    });
    useEffect(() => {
        if (show) {
            set_show(true);
        } else {
            setTimeout(() => {
                set_show(false);
            }, duration);
        }
    }, [show, duration]);
    return _show ?
        <animated.span
            className={`${className} block`}
            style={{ ...styles, ...style }}
        >
            {children}
        </animated.span>
        : null;

}
